module.exports = __webpack_public_path__ + "img/1122107410.42fdb504.jpg";